module.exports = __webpack_public_path__ + "img/354.a43cc484.png";